export default __webpack_public_path__ + "spreadsheets/planilha-exemplo.csv";